import AbstractSystem from "../all/AbstractSystem";

class OperaSystem extends AbstractSystem {
    
    exit() {
        window.open('/node/homeuser', '_self', '');
        window.close();
    }
}

export default OperaSystem;



// WEBPACK FOOTER //
// ./src/devices/opera/System.js